import echarts from "echarts"

function drawBarLinechart(ref, xname, totaldata, linedata, maxscore, minscore, title, name) {
  let mychart = echarts.init(ref)
  // let totaldata = []
  // for (let i in maxscore)
  // {
  //   totaldata.push(maxscore[i] + minscore[i])
  // }
  console.log(maxscore,)
  mychart.setOption({
    backgroundColor: "#FFFFFF",
    "tooltip": {
      "trigger": "axis",
      "axisPointer": {
        "type": "none",
        textStyle: {
          color: "#fff"
        }
      },
      formatter: function (a) {
        return '<div><p>' + a[0].name + '</p><p>最高分：' + a[1].value + '</p>' + '<p>最低分：' + a[3].value + '</p>' + '<p>平均分：' + a[1].value + '</p></div>'
      }
    },

    dataZoom: [{
      "show": true,
      "height": 20,
      "xAxisIndex": [
        0
      ],
      bottom: "8%",
      "start": 20,
      "end": 80,
      handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
      handleSize: "110%",
      handleStyle: {
        color: "#d3dee5",

      },
      textStyle: {
        color: "#000"
      },
      borderColor: "#90979c"
    }, {
      type: "inside",
      start: 0,
      end: 100
    }],
    title: {
      text: title,
      top: 20,
      left: 18,
      textStyle: {
        color: "#333333",
        fontSize: 16,
      },
    },
    "grid": {
      "borderWidth": 0,
      "top": 60,
      "bottom": 65,
      "right": 70,
      textStyle: {
        color: "#333333"
      }
    },
    "calculable": true,
    "xAxis": [{
      "type": "category",
      "axisLine": {
        show: true,
        symbolSize: (100, 8),
        symbol: ["none", "arrow"],
        lineStyle: {
          color: "#333333",
        },
      },

      "axisTick": {
        "show": false
      },
      "splitArea": {
        "show": false
      },
      "axisLabel": {
        // "interval": ,
        color: "#969A9F",
        fontSize: 14
      },
      "data": xname,
    }],
    "yAxis": [{
      "type": "value",
      "splitLine": {
        "show": false
      },
      // boundaryGap: ["0%", "20%"],
      "axisLine": {
        show: true,
        symbolSize: (100, 8),
        symbol: ["none", "arrow"],
        lineStyle: {
          color: "#333333",
        },
      },
      "axisTick": {
        "show": false
      },
      "axisLabel": {
        "interval": 0,
        color: "#969A9F",
        fontSize: 20

      },
      "splitArea": {
        "show": false
      },

    }],
    "series": [
      {
        // name: "总分和",
        "type": "bar",
        "stack": "总量",
        "itemStyle": {
          "barBorderColor": "rgba(0,0,0,0)",
          "color": "rgba(0,0,0,0)",
        },
        label: {
          show: false,
          position: 'top',
          color: 'white'
        },
        "emphasis": {
          "itemStyle": {
            "barBorderColor": "rgba(0,0,0,0)",
            "color": "rgba(0,0,0,0)"
          }
        },
        "data": totaldata
      },
      {
        "name": "平均分",
        "type": "line",
        "stack": "总量",
        symbolSize: 1,
        symbol: "circle",
        "itemStyle": {
          "normal": {
            "color": "rgba(255, 196, 53, 1)",
            "barBorderRadius": 0,
          }
        },
        lineStyle: {
          normal: {
            width: 4,
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: "#FF965A " // 0% 处的颜色
              }, {
                offset: 1,
                color: "#FFDA54" // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          }
        },
        "data": linedata
      },
      {
        "name": "最高分",
        "type": "bar",
        "stack": "总量",
        "barMaxWidth": 35,
        "barGap": "10%",
        "itemStyle": {
          "normal": {
            "color":
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: "rgb(48,65,86) " // 0% 处的颜色
                }, {
                  offset: 1,
                  color: "rgb(48,65,86)" // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
          }
        },
        "data": maxscore
      },

      {
        "name": "最低分",
        "type": "bar",
        "stack": "总量",
        "itemStyle": {
          "normal": {
            "color": {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: "rgb(60,160,255)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgb(48,65,86)" // 100% 处的颜色
              }],
              global: false // 缺省为 false
            },
            "barBorderRadius": 0
          }
        },
        "data": minscore
      },
    ]
  })
}

export {
  drawBarLinechart
}
